import React, { useState } from 'react';

import InputField from '../../ui/input-field/input-field';
import { ILibraryOpeningHoursException } from '@/lib/fragments/libraryOpeningHoursException';
import { ILibraryOpeningHours } from '@/lib/fragments/libraryOpeningHours';
import LinkWrapper from '@/components/link-wrapper/link-wrapper';
import { OpeningHours } from '@/components/opening-hours/opening-hours';
import { useGetLibraryConstantsDictionaryData } from '@/providers/ConfigProvider';

export interface TenantOpeningHoursBlockProps {
  title: string;
  node_locale: string;
  placeholder?: string;
  tenantOpeningHoursDetails?: {
    name: string;
    openingHours: ILibraryOpeningHours;
    openingHoursExceptions: ILibraryOpeningHoursException[];
    timezone: string;
    slug: string;
  }[];
  meetingPlaceOpeningHours?: {
    openingHours?: ILibraryOpeningHours;
    openingHoursExceptions?: ILibraryOpeningHoursException[];
    timezone?: string;
  };
}
interface IMeetingPlaceOrTenantOpeningHours {
  name: string | null;
  timezone: string;
  openingHours: ILibraryOpeningHours | null;
  openingHoursExceptions: ILibraryOpeningHoursException[] | null;
  slug?: string;
}

const TenantOpeningHoursBlock = ({
  title,
  node_locale,
  placeholder,
  tenantOpeningHoursDetails,
  meetingPlaceOpeningHours,
}: TenantOpeningHoursBlockProps) => {
  if (tenantOpeningHoursDetails) {
    tenantOpeningHoursDetails = tenantOpeningHoursDetails.sort((a, b) => {
      if (a.name && b.name) {
        return a.name
          .trim()
          .toLocaleLowerCase()
          .localeCompare(b.name.trim().toLocaleLowerCase());
      }
      return 0;
    });
  }

  const dictionary = useGetLibraryConstantsDictionaryData();

  const [selectedTenant, setSelectedTenant] =
    useState<IMeetingPlaceOrTenantOpeningHours | null>(null);

  const handleOnChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const searchString = event.currentTarget.value;
    const foundTenant =
      tenantOpeningHoursDetails &&
      tenantOpeningHoursDetails.find((tenant) => tenant.name === searchString);
    if (foundTenant) {
      setSelectedTenant(foundTenant);
    }
  };

  return (
    <>
      <h2 className="mb-5 font-title text-headingl text-text-default lg:mb-8 lg:text-headingxxl">
        {title}
      </h2>
      <InputField
        name="search"
        list="tenantList"
        type="search"
        id="search"
        label=""
        placeholder={
          placeholder ? placeholder : 'Missing placeholder in Contentful'
        }
        autoComplete={false}
        disabled={false}
        onChange={handleOnChange}
        className={'openingHourSearch'}
      />
      <datalist id="tenantList">
        {tenantOpeningHoursDetails &&
          tenantOpeningHoursDetails.map((tenant, index) => (
            <option key={index} value={tenant.name ?? ''} />
          ))}
      </datalist>

      {selectedTenant && meetingPlaceOpeningHours?.openingHours && (
        <>
          <div className="mb-3 mt-6 text-headings">{selectedTenant.name}</div>
          <OpeningHours
            node_locale={node_locale}
            openingHours={
              selectedTenant?.openingHours
                ? selectedTenant?.openingHours
                : meetingPlaceOpeningHours?.openingHours
            }
            variant="block-compact-exceptions"
            openingHoursClosed={dictionary?.openingHoursClosed ?? ''}
            openingHoursClosedToday={dictionary?.openingHoursClosedToday ?? ''}
            openingHoursExceptions={
              selectedTenant.openingHoursExceptions
                ? selectedTenant.openingHoursExceptions
                : meetingPlaceOpeningHours?.openingHoursExceptions
                  ? meetingPlaceOpeningHours?.openingHoursExceptions
                  : []
            }
            openingHoursOpenToday={dictionary?.openingHoursOpenToday ?? ''}
            timezone={
              selectedTenant.timezone ?? meetingPlaceOpeningHours?.timezone
            }
            openingHoursBlockExceptionTitle={
              dictionary?.openingHoursBlockExceptionTitle
            }
          />
          {selectedTenant.slug && (
            <div className="mt-6">
              <LinkWrapper data={selectedTenant.slug} className="underline">
                {dictionary?.openingHoursTenantBlockLinkTitle}
              </LinkWrapper>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default TenantOpeningHoursBlock;

// export const query = graphql`
//   fragment BlockTenantOpeningHours on ContentfulBlockTenantOpeningHours {
//     blocktype: __typename
//     id
//     node_locale
//     title
//     placeholder
//   }
// `;
